import React, { useEffect, useState } from 'react';
import { IUser } from '../Interfaces/IUser';
import { ILegalTransaction } from '../Interfaces/ILegalTransaction';
import { Collapse, MenuItem, TextField, Typography } from '@mui/material';
import { AddCircle, Celebration } from '@mui/icons-material';
import { ILegalRequirement } from '../Interfaces/ILegalRequirement';
import { ILegalTransactionMeeting } from '../Interfaces/ILegalTransactionMeeting';
import { castNoTimeZone, DashboardOwn } from './DashboardOwn';
import { DashboardGlobal } from './DashboardGlobal';
import { LoadingSpinner } from '../core/LoadingSpinner';
import {
  useGetLegalTransactionMeetings,
  useGetLegalTransactionProgresses,
  useGetLegalTransactions,
} from '../hooks/reactQuerys/LegalTransactionQueries';
import {
  useGetLegalRequirements,
  useGetLegalRequirementsSmall,
} from '../hooks/reactQuerys/LegalRequirementQueries';
import {
  useGetUserGroups,
  useGetUsers,
} from '../hooks/reactQuerys/UserQueries';

export const DashboardMain: React.FC = () => {
  const { userGroups, isLoadingUserGroups } = useGetUserGroups();
  const { legalTransactions, isLoadingLegalTransactions } =
    useGetLegalTransactions();
  const { users, isLoadingUsers } = useGetUsers();
  const { legalTransactionProgresses, isLoadingLegalTransactionProgresses } =
    useGetLegalTransactionProgresses();

  const { legalTransactionMeetings, isLoadingLegalTransactionMeetings } =
    useGetLegalTransactionMeetings();

  const idUser = Number(localStorage.getItem('idUser'));
  const [currentView, setCurrentView] = useState<
    'view_global' | 'view_own' | string
  >('view_global');

  const [currentUserLegaLReqDeadline, setCurrentUserLegalReqDeadline] =
    useState<ILegalRequirement[]>([]);

  const [currentUserLegalArray, setCurrentUserLegalArray] = useState<
    ILegalTransaction[]
  >([]);
  const [currentUserReqArray, setCurrentUserReqArray] = useState<
    ILegalRequirement[]
  >([]);
  const [currentUserMeetingArray, setCurrentUserMeetingArray] = useState<
    ILegalTransactionMeeting[]
  >([]);

  const currentUser = users?.find(x => x.idUser === idUser);

  useEffect(() => {
    if (currentUser !== undefined && legalTransactions !== undefined) {
      if (Boolean(currentUser.isNotary)) {
        setCurrentUserLegalArray([
          ...legalTransactions
            .filter(x => x.Closed_at === null)
            .filter(x => x.Notary_idUser !== null)
            .filter(x => x.Notary_idUser === idUser),
        ]);
      } else {
        setCurrentUserLegalArray([
          ...legalTransactions
            .filter(x => x.Closed_at === null)
            .filter(x => x.Employee_idUser !== null)
            .filter(x => x.Employee_idUser === idUser),
        ]);
      }
    } else {
    }
  }, [currentUser, legalTransactions]);

  useEffect(() => {
    if (legalTransactionMeetings !== undefined) {
      const ownLegalTransactions = currentUserLegalArray.map(
        x => x.idLegalTransaction
      );
      setCurrentUserMeetingArray(
        legalTransactionMeetings
          .filter(x => ownLegalTransactions.indexOf(x.idLegalTransaction) > -1)
          .filter(x => castNoTimeZone(x.Meeting_at) >= new Date())
      );
    }
  }, [legalTransactionMeetings, currentUserLegalArray]);

  const getRightGreeding = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 17) {
      return 'Guten Abend, ';
    } else if (currentHour >= 11) {
      return 'Guten Tag, ';
    } else {
      return 'Guten Morgen, ';
    }
  };

  const getGender = (currentUser: IUser) => {
    if (currentUser.idGender === 1) {
      return 'Herr';
    } else if (currentUser.idGender === 2) {
      return 'Frau';
    } else {
      return '';
    }
  };

  if (
    isLoadingLegalTransactionMeetings ||
    isLoadingLegalTransactionProgresses ||
    isLoadingUsers ||
    isLoadingUserGroups ||
    isLoadingLegalTransactions ||
    !currentUser
  ) {
    return <LoadingSpinner />;
  }

  if (
    !legalTransactionMeetings ||
    !legalTransactionProgresses ||
    !users ||
    !userGroups ||
    !legalTransactions
  ) {
    return <>Fehler!</>;
  }

  return (
    <>
      <Typography variant='h4'>
        {getRightGreeding()} {getGender(currentUser)} {currentUser.LastName}!
      </Typography>

      <TextField
        label='Ansicht'
        sx={{ float: 'right' }}
        value={currentView}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setCurrentView(event.target.value)
        }
        select
      >
        <MenuItem value='view_global'>Globale Ansicht</MenuItem>
        <MenuItem value='view_own'>Meine Ansicht</MenuItem>
      </TextField>

      <Typography sx={{ mt: 2 }}>
        Heute wurden <AddCircle sx={{ fontSize: 13 }} />{' '}
        <b>
          {
            legalTransactions.filter(
              x =>
                new Date(x.Created_at).toDateString() ===
                new Date().toDateString()
            ).length
          }
        </b>{' '}
        Vorgänge erstellt und &nbsp;
        <Celebration sx={{ fontSize: 13 }} />{' '}
        <b>
          {
            legalTransactions
              .filter(x => x.Closed_at !== null)
              .filter(
                x =>
                  new Date(String(x.Closed_at)).toDateString() ===
                  new Date().toDateString()
              ).length
          }
        </b>
        &nbsp;Vorgänge abgeschlossen.
        <br />
        Insgesamt liegen{' '}
        <b>{legalTransactions.filter(x => x.Closed_at === null).length}</b>{' '}
        offene Vorgänge vor.
      </Typography>

      <Collapse in={currentView === 'view_global'}>
        <DashboardGlobal
          userArray={users}
          userGroupArray={userGroups}
          legalTransactionArray={legalTransactions}
          legalTransactionProgressArray={legalTransactionProgresses}
        />
      </Collapse>

      <Collapse in={currentView === 'view_own'}>
        <DashboardOwn
          currentUserLegalArray={currentUserLegalArray}
          currentUserMeetingArray={currentUserMeetingArray}
          currentUserReqArray={currentUserReqArray}
          currentUserlegalReqDeadline={currentUserLegaLReqDeadline}
        />
      </Collapse>
    </>
  );
};
